import { render, staticRenderFns } from "./main-shop-categories.vue?vue&type=template&id=49765030&"
import script from "./main-shop-categories.vue?vue&type=script&lang=js&"
export * from "./main-shop-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports